import http from "../core/api/httpClient";

const AZURE_SUBSCRIBER_LOGIN_URL =
  "https://nb-marketplace-api-gwc7ctenhqgtfsgu.centralindia-01.azurewebsites.net/api/subscriber-login";

interface EmailOtpStartResult {
  email_otp_start_session_id: string;
  expires_in: number;
}

interface EmailOtpVerifyResult {
  control_plane_jwt: string;
  user_id: string;
}

export const authService = {
  async loginWithAzure(idToken: string): Promise<any> {
    const res = await http.post(AZURE_SUBSCRIBER_LOGIN_URL, { idToken });
    return res.data;
  },
  async startEmailOtp(email: string): Promise<EmailOtpStartResult> {
    const res = await http.post<EmailOtpStartResult>("/email-otp-start", {
      username: email,
    });
    return res.data;
  },
  async verifyEmailOtp(
    emailOtpStartSessionId: string,
    otp: string,
  ): Promise<EmailOtpVerifyResult> {
    const res = await http.post<EmailOtpVerifyResult>("/email-otp-verify", {
      email_otp_start_session_id: emailOtpStartSessionId,
      otp,
    });
    return res.data;
  },
};
